/**
 * Created by Christof Sander on 27.09.2016.
 */

const utils = require('frontend-controller/lib/utils')

module.exports = {
	extends: [
		'/',
		'templates',
		'layoutTrees',
		'layoutTrees'
	],

	config: {
		showLayoutsOnly: true
	},

	actions: {
		addTree: {
			source: {
				load: {
					componentData: {
						config: {
							lastMileSelector: 'section.filterContent section.colWrap'
						}
					}
				}
			}
		}
	},

	methods: {
		// TODO: DOC!
		onTreeAction: function (data) {
			var self = this;
			// TODO: CLEANUP
			// console.log('LayoutTrees - onTreeAction', data, this.model.states);

			switch (data.onTreeActionOptions.eventType) {
				case 'select_node.jstree':
					if(!data.onTreeActionOptions.autoSelect || (this.config.decisionOptions && this.config.decisionOptions.decideOnAutoSelect)) {
						// TODO: impl. animation and animation-delay
						// show page actions if necessary
						this.parentComponents(undefined, function (parentComponent) {
							if (utils.isFunction(parentComponent.hooks.onDecision)) {
								parentComponent.trigger('onDecision', {
									decisionComponent: self,
									decisionType: 'submit',
									decisionOptions: self.config.decisionOptions || {},
									data: data.onTreeActionOptions.nodeData
								});
								return false;
							}
						});
					}
					break;
			}
		},

		/**
		 * this function will be called by the trees-component after the attach hook has been done.
		 * NOTE: this gives us the ability to react on the attach hook without overwriting it.
		 */
		onAttachDone: function(){}
	},

	// NOTE: prevent layoutTrees handlers from being called for this selectLayoutTrees-Component
	handlers: undefined
};
